import { NotifyHelper } from "../../../helpers/toast";
import { eDichVuThanhToanActionsObj } from "../../action-types/dich-vu/IDichVuThanhToanActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const dichVuThanhToanActions = {
  ...generateActions(eDichVuThanhToanActionsObj, "DICH_VU_THANH_TOAN"),
  ...generateActionForKey(
    eDichVuThanhToanActionsObj,
    "DICH_VU_THANH_TOAN",
    "SAVE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã cập nhật");
    }
  ),
  ...generateActionForKey(
    eDichVuThanhToanActionsObj,
    "DICH_VU_THANH_TOAN",
    "SAVE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eDichVuThanhToanActionsObj,
    "DICH_VU_THANH_TOAN",
    "DELETE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã xóa");
    }
  ),
  ...generateActionForKey(
    eDichVuThanhToanActionsObj,
    "DICH_VU_THANH_TOAN",
    "DELETE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eDichVuThanhToanActionsObj,
    "DICH_VU_THANH_TOAN",
    "PHAT_HANH_HOA_DON_SUCCESS",
    () => {
      NotifyHelper.Success("Thành công");
    }
  ),
  ...generateActionForKey(
    eDichVuThanhToanActionsObj,
    "DICH_VU_THANH_TOAN",
    "PHAT_HANH_HOA_DON_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eDichVuThanhToanActionsObj,
    "DICH_VU_THANH_TOAN",
    "DONG_BO_HOA_DON_STATUS_START",
    () => {
      NotifyHelper.Success("Thành công");
    }
  ),
  ...generateActionForKey(
    eDichVuThanhToanActionsObj,
    "DICH_VU_THANH_TOAN",
    "DONG_BO_HOA_DON_STATUS_ERRR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
};
